export default __webpack_public_path__ + "static/media/image-board-study-now-n-w@2x.33f07c2c.webp";